import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Marcador } from "../../types/marcador/Marcador";
import useMarcadorFetch from "./useMarcadorFetch";





type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: Marcador | null;

    handleSearchChange: (newValue: Marcador) => void;
};


const TxtMarcador = ({
    isdisabled,
    isLoading,

    required,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useMarcadorFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete

            value={value && value.id ? value : null} // 
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option) => {

                const marcador = option as Marcador;
                let descricao: string = "";
                if (!marcador) {
                    return '';
                }

                if (marcador.descricao) {
                    descricao = marcador.descricao;
                }

                if (marcador.usuario?.cpf) {
                    descricao = "(" + marcador.usuario.cpf + ") " + descricao;
                }
                return descricao;
                //return marcador.descricao ? marcador.descricao : "";
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as Marcador);
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Marcador"
                    required={required ? true : false}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );
}
export default TxtMarcador;

